module.exports = __webpack_public_path__ + "static/media/Chapter.877e6983.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/PDFFiles/Chapter.pdf
// module id = 1933
// module chunks = 1